import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { MatCard } from '@angular/material/card';
import { ProductLinkDirective } from '@libs/shared/ui';
import { ProductModel } from '@libs/shop/models';
import { AddToCartSmallComponent } from '../../elements/add-to-cart-small';
import { ProductPriceFormatterComponent } from '../product-prices/product-price-formatter';

@Component({
  selector: 'ui-product-card-small',
  imports: [
    ProductLinkDirective,
    ProductPriceFormatterComponent,
    AddToCartSmallComponent,
    MatCard,
  ],
  templateUrl: './product-card-small.component.html',
  styleUrl: './product-card-small.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCardSmallComponent {
  public isPromotion: InputSignal<boolean> = input(false);
  public product: InputSignal<ProductModel> = input.required();
  public position: InputSignal<number> = input.required();
  public enableProductClickTracking: InputSignal<boolean> = input(true);

}
